import { Component, OnInit, ViewChild } from '@angular/core';
import { PromocodeBase } from '../../promocode-base';
import { OriginalityService } from '../../../../services/originality.service';
import { MessageService } from 'primeng';
import { DatePipe } from '@angular/common';
import { ThesisOrderModel } from '../../../../models/thesis-order.model';
import {
  createSubQuery,
  createSubQueryForMoreObjectsAndFields,
} from '../../../../../core-frontend-common/misc/query-designer/query-designer-functions';
import {
  QueryDesignerSearch,
  queryFilterTypes,
  queryOperators,
} from '../../../../../core-frontend-common/misc/query-designer/query-designer';
import { GeneratePromocodeEmailComponent } from './generate-promocode-email/generate-promocode-email.component';
import { PRINT_ORDER_STATUSES } from '../../../../constants';

@Component({
  selector: 'smart-discount-user-section',
  templateUrl: './discount-user-section.component.html',
  styleUrls: ['./discount-user-section.component.scss']
})
export class DiscountUserSectionComponent extends PromocodeBase implements OnInit {

  filter = {
    search: '',
    year: new Date(),
    status: [
      {
        'id': 10,
        'title': 'PKO_EVALUATED'
      }
    ]
  };

  table = {
    totalItems: 0,
    page: 1,
    pageSize: 15
  };

  thesisOrderStates = PRINT_ORDER_STATUSES;

  loading = false;

  thesisOrders: ThesisOrderModel[] = [];

  currentFilter = null;

  @ViewChild(GeneratePromocodeEmailComponent, {static: false}) generatePromocodeDialog: GeneratePromocodeEmailComponent;

  constructor(
    private originality: OriginalityService,
    private datePipe: DatePipe,
    private messageService: MessageService
  ) {
    super();
  }

  ngOnInit() {

  }

  async getThesisOrders(filter) {

    this.loading = true;

    this.originality
      .getOriginalityDataByFilter(filter)
      .subscribe(v => {
        this.thesisOrders = v.items;
        this.table.totalItems = v.totalItems;
        this.loading = false;
      }, error => {
        console.log(error);
        this.table.totalItems = 0;
        this.thesisOrders = [];
        this.loading = false;
      });

  }

  filterChanged() {

  }

  setPage(pageInfo) {
    this.table.page = (pageInfo.first + pageInfo.rows) / 15;
    this.submitFilter();
  }

  submitFilter() {
    const query = {
      status: {},
      year: {}
    };

    if (this.filter.year) {
      query.year = createSubQueryForMoreObjectsAndFields(queryOperators.AND, [
        {
          obj: `${this.filter.year.getFullYear()}-01-01T00:01:01`,
          filterType: queryFilterTypes.GreaterThanOrEqual,
          field: 'CreatedDatetime'
        },
        {
          obj: `${this.filter.year.getFullYear()}-12-31T00:01:01`,
          filterType: queryFilterTypes.LessThanOrEqual,
          field: 'CreatedDatetime'
        }
      ]);
    }

    if (this.filter.status && this.filter.status.length > 0) {
      query.status = createSubQuery(queryOperators.OR, this.filter.status, 'status', queryFilterTypes.EQUAL, 'id');
    }

    const queryDesigner = {
      'search': [],
      'where': {
        'operatorType': 'AND',
        'operands': []
      },
      'orderBy': [
        {
          'field': 'CreatedDatetime',
          'order': 'DESC'
        },
        {
          'field': 'Id',
          'order': 'DESC'
        }
      ],
      'page': this.table.page,
      'pageSize': this.table.pageSize
    };


    if (this.filter.search && this.filter.search.length > 0) {
      const search = new QueryDesignerSearch();
      search.fields = ['payerEmail'];
      search.value = this.filter.search;

      // @ts-ignore
      queryDesigner.search = search;
    } else {
      delete queryDesigner.search;
    }

    Object.keys(query)
      .forEach(queryItem => {
        if (Object.keys(query[queryItem]).length > 0 && queryItem !== 'search') {
          queryDesigner['where']['operands'].push(query[queryItem]);
        }
      });

    this.currentFilter = queryDesigner;

    this.getThesisOrders(queryDesigner);
  }

  generateEmailWithPromocode() {
    this.generatePromocodeDialog.openModal(this.currentFilter);
  }

  refreshData() {
    this.forceRefresh.emit(true);
  }

}
